
<script>
import CostTypeService from "@/store/services/costtype.service.js";
import ArchiveBase from "@/components/base_components/ArchiveBase.vue";

export default {
    name: "CostTypeArchive",
    extends: ArchiveBase,
    methods: {
        extendable(){
            this.swapState();
            this.$emit('archive', this.item);
        }
    }
};
</script>